import { apiRequest } from './api'

export function listTrustAccounts() {
  return apiRequest('/trust-accounts/list', {
    method: 'POST',
  })
}

export function createTrustAccount(payload) {
  return apiRequest('/trust-accounts/create', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function depositTrustAccount(payload) {
  return apiRequest('/trust-accounts/deposit', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function withdrawTrustAccount(payload) {
  return apiRequest('/trust-accounts/withdraw', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function listTrustAccountTransactions(trustAccountId) {
  return apiRequest('/trust-accounts/transactions/list', {
    method: 'POST',
    body: JSON.stringify(trustAccountId != null ? { trustAccountId } : {}),
  })
}

export function deleteTrustAccount(trustAccountId) {
  return apiRequest('/trust-accounts/delete', {
    method: 'POST',
    body: JSON.stringify({ trustAccountId }),
  })
}
